// Cheesy, trader-friendly loading messages — replace technical "Computing wave structure"
// labels that would otherwise leak our Elliott Wave IP to users.
const SIGNAL_LOADING_MESSAGES = [
  "Looking for green bucks…",
  "Hunting the next setup…",
  "Sniffing out smart money…",
  "Reading the tape…",
  "Cooking the next signal…",
  "Where's the alpha hiding?…",
  "Mapping the next move…",
  "Stalking the chart…",
  "Catching the wave (the good one)…",
  "Spotting the edge…",
  "Following the smart money…",
  "Calibrating the crystal ball…",
  "Sharpening the pencils…",
  "Reading between the candles…",
  "Counting the bulls and bears…",
  "Whispering to the price action…",
];

const NEWS_LOADING_MESSAGES = [
  "Scanning the noise…",
  "Cutting through the headlines…",
  "Sniffing out market chatter…",
  "Reading the global mood…",
  "What's the world saying?…",
  "Hunting for the catalyst…",
  "Filtering the FUD…",
  "Tuning into market vibes…",
];

export function randomSignalLoadingMsg() {
  return SIGNAL_LOADING_MESSAGES[Math.floor(Math.random() * SIGNAL_LOADING_MESSAGES.length)];
}

export function randomNewsLoadingMsg() {
  return NEWS_LOADING_MESSAGES[Math.floor(Math.random() * NEWS_LOADING_MESSAGES.length)];
}
